import React from "react"
import OrderItem from "../OrderItem"

function List({ contacts }) {
	return (
		<ul>
			{!!contacts &&
				contacts.map((item) => {
					return (
						<OrderItem key={item.id} order={item}>
							{item.msisdn}
						</OrderItem>
					)
				})}
		</ul>
	)
}

export default List
